import {
  faCalendarDays,
  faCircleDot,
  faFileSignature,
  faInputText,
  faListDropdown,
  faRectangleList,
  faSignature,
  faSquareCheck,
} from '@fortawesome/pro-regular-svg-icons';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { AnnotationTypeEnum } from '../../utils/types';
import { SidePanelButton } from '../sidePanel.styled';

export const DraggableAnnotation = ({
  type,
  label,
  onDragStart,
  onDragEnd,
  isDraggable = true,
}: {
  type: string;
  label: string;
  onDragStart?: any;
  onDragEnd?: any;
  isDraggable?: boolean;
}) => {
  let icon;
  switch (type) {
    case AnnotationTypeEnum.TextField:
      icon = faInputText;
      break;
    case AnnotationTypeEnum.SIGNATURE:
      icon = faFileSignature;
      break;
    case AnnotationTypeEnum.CheckBox:
      icon = faSquareCheck;
      break;
    case AnnotationTypeEnum.RadioButton:
      icon = faCircleDot;
      break;
    case AnnotationTypeEnum.INITIAL:
      icon = faSignature;
      break;
    case AnnotationTypeEnum.ComboBox:
      icon = faListDropdown;
      break;
    case AnnotationTypeEnum.ListBox:
      icon = faRectangleList;
      break;
    case AnnotationTypeEnum.DateAndTimeField:
      icon = faCalendarDays;
      break;
    case AnnotationTypeEnum.SIGNATURE_WITH_DATE_SIGNED:
      icon = faFileSignature;
      break;
    default:
      icon = faInputText;
      break;
  }

  return (
    <SidePanelButton
      draggable={isDraggable}
      onDragStart={async (e: React.DragEvent) =>
        isDraggable && (await onDragStart(e, type))
      }
      onDragEnd={(e: React.DragEvent) => isDraggable && onDragEnd(e, type)}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
        }}
      >
        <FontAwesomeIcon
          style={{ display: 'inline', width: '20px' }}
          icon={icon}
        />
        <span style={{ display: 'inline' }}>{label}</span>
      </Box>
      <FontAwesomeIcon
        style={{ display: 'inline' }}
        icon={faGripDotsVertical}
      />
    </SidePanelButton>
  );
};

export function createDragImage(type: any, color: any): HTMLElement {
  let dragImage: HTMLElement = document.createElement('div');

  switch (type) {
    case AnnotationTypeEnum.SIGNATURE:
      dragImage.setAttribute('type', 'text');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Signature';
      dragImage.style.width = '120px';
      dragImage.style.height = '60px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.borderWidth = '1px';
      break;
    case AnnotationTypeEnum.INITIAL:
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Signature';
      dragImage.style.width = '80px';
      dragImage.style.height = '52px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.borderWidth = '1px';
      break;
    case AnnotationTypeEnum.RadioButton:
      dragImage = document.createElement('input');
      dragImage.setAttribute('type', 'radio');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-RadioButton';
      dragImage.style.width = '24px';
      dragImage.style.height = '24px';
      dragImage.style.backgroundColor = '#8CB8DB !important';
      dragImage.style.border = '1px solid #3E7BAD !important';
      dragImage.style.boxShadow = 'none  !important';
      dragImage.style.borderRadius = '50%';
      break;
    case AnnotationTypeEnum.CheckBox:
      dragImage = document.createElement('input');
      dragImage.setAttribute('type', 'checkbox');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-CheckBox';
      dragImage.style.width = '24px';
      dragImage.style.height = '24px';
      dragImage.style.backgroundColor = '#8CB8DB !important';
      dragImage.style.boxShadow = 'none !important';
      dragImage.style.borderWidth = '1px';
      dragImage.style.borderStyle = 'solid';
      dragImage.style.borderColor = '#3E7BAD !important';
      break;
    case AnnotationTypeEnum.TextField:
      dragImage = document.createElement('input');
      dragImage.setAttribute('type', 'text');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Text';
      dragImage.style.width = '120px';
      dragImage.style.height = '40px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.border = 'none';
      break;
    case AnnotationTypeEnum.ComboBox:
      dragImage = document.createElement('select');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-ComboBox';
      dragImage.style.width = '120px';
      dragImage.style.height = '40px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.border = 'none';
      break;
    case AnnotationTypeEnum.ListBox:
      dragImage = document.createElement('select');
      dragImage.setAttribute('multiple', 'true');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-ListBox';
      dragImage.style.width = '120px';
      dragImage.style.height = '40px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.border = 'none';
      break;
    case AnnotationTypeEnum.DateAndTimeField:
      dragImage = document.createElement('input');
      dragImage.setAttribute('type', 'text');
      dragImage.setAttribute('placeholder', 'm/d/yyyy HH:MM');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Text';
      dragImage.style.width = '120px';
      dragImage.style.height = '40px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.border = 'none';
      break;
    case AnnotationTypeEnum.SIGNATURE_WITH_DATE_SIGNED:
      dragImage = document.createElement('input');
      dragImage.setAttribute('type', 'text');
      dragImage.setAttribute('placeholder', 'signature with date signed');
      dragImage.className =
        'PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Text';
      dragImage.style.width = '120px';
      dragImage.style.height = '40px';
      dragImage.style.backgroundColor = '#ecf0ffe6';
      dragImage.style.border = 'none';
      break;
  }

  return dragImage;
}
